/**
 * Song of Roland metadata + config
 */

const metadataChapters = [
  { chapt_num: 1, chapt_name: "Charlemagne's Conquest and Marsile's Plot", subtitle: 'Stanzas 1 - 20', hasAssessment: true, chunk: 'chunk00'},
  { chapt_num: 2, chapt_name: "The Saracen Embassy to Charlemagne", subtitle: 'Stanzas 21 - 40', hasAssessment: true, chunk: 'chunk01'},
  { chapt_num: 3, chapt_name: "Debate Among the Franks", subtitle: 'Stanzas 41 - 60', hasAssessment: true, chunk: 'chunk02'},
  { chapt_num: 4, chapt_name: "The Betrayal of Ganelon", subtitle: 'Stanzas 61 - 80', hasAssessment: true, chunk: 'chunk03'},
  { chapt_num: 5, chapt_name: "Preparing the Rearguard", subtitle: 'Stanzas 81 - 100', hasAssessment: true, chunk: 'chunk04'},
  { chapt_num: 6, chapt_name: "Marsile's Army Gathers", subtitle: 'Stanzas 101 - 120', hasAssessment: true, chunk: 'chunk05'},
  { chapt_num: 7, chapt_name: "The Franks Await Battle", subtitle: 'Stanzas 121 - 140', hasAssessment: true, chunk: 'chunk06'},
  { chapt_num: 8, chapt_name: "The Battle of Roncevaux Begins", subtitle: 'Stanzas 141 - 160', hasAssessment: true, chunk: 'chunk07'},
  { chapt_num: 9, chapt_name: "The Slaughter of the Franks", subtitle: 'Stanzas 161 - 180', hasAssessment: true, chunk: 'chunk08'},
  { chapt_num: 10, chapt_name: "Roland Sounds the Horn", subtitle: 'Stanzas 181 - 200', hasAssessment: true, chunk: 'chunk09'},
  { chapt_num: 11, chapt_name: "The Death of Roland", subtitle: 'Stanzas 201 - 220', hasAssessment: false, chunk: 'chunk10'},
  { chapt_num: 12, chapt_name: "The Discovery at Roncevaux", subtitle: 'Stanzas 221 - 240', hasAssessment: false, chunk: 'chunk11'},
  { chapt_num: 13, chapt_name: "Charlemagne's Vengeance", subtitle: 'Stanzas 241 - 260', hasAssessment: false, chunk: 'chunk12'},
  { chapt_num: 14, chapt_name: "The Capture of Baligant", subtitle: 'Stanzas 261 - 280', hasAssessment: true, chunk: 'chunk13'},
  { chapt_num: 15, chapt_name: "Justice and Judgment", subtitle: 'Stanzas 281 - 291', hasAssessment: true, chunk: 'chunk14'}
];

const extractStanzaRange = (subtitle) => {
  if (!subtitle || typeof subtitle !== 'string') return null;
  const trimmed = subtitle.trim();
  const prefix = 'Stanzas ';
  return trimmed.startsWith(prefix) ? trimmed.slice(prefix.length) : null;
};

export const chapters = metadataChapters.map((chapter) => ({
  chapter_id: chapter.chapt_num,
  chapt_num: chapter.chapt_num,
  chapt_name: `Chapter ${chapter.chapt_num}: ${chapter.chapt_name}`,
  subtitle: chapter.subtitle,
  stanzaRange: extractStanzaRange(chapter.subtitle),
  hasAssessment: chapter.hasAssessment,
  chunk: chapter.chunk
}));

const getChapterByChunk = (chunk) => chapters.find(ch => ch.chunk === chunk);

export const config = {
  id: 'SongOfRoland',
  displayName: 'The Song of Roland',
  author: 'Anonymous',
  coverImage: 'SongRoland.png',
  route: 'Roland',
  type: 'epic',
  contentKey: 'SongOfRoland',
  bookId: 'song-of-roland',
  usesExternalLinks: false,

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter) {
      if (chapter.chapt_name && chapter.chapt_name.trim()) {
        return chapter.chapt_name.trim();
      }
      return `Chapter ${chapter.chapt_num}`;
    }
    const chunkNum = parseInt(chunk.replace('chunk', ''), 10);
    return `Chapter ${chunkNum + 1}`;
  },

  getSubtitle: function(fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.subtitle) {
      return chapter.subtitle;
    }
    if (fragmentRange?.start && fragmentRange?.end) {
      return `Stanzas ${fragmentRange.start} - ${fragmentRange.end}`;
    }
    return 'The Song of Roland (La Chanson de Roland)';
  }
};

const book = { config, chapters };

export default book;
